import { Circle, Eye, Wrench, CheckCircle2, BellRing, ArchiveX, StickyNote, ImagePlus, RefreshCcw, Sparkles } from "lucide-react";

const ICON = {
  created: Sparkles,
  viewed: Eye,
  action_selected: Wrench,
  completed: CheckCircle2,
  reminder_scheduled: BellRing,
  reactivated: RefreshCcw,
  dismissed: ArchiveX,
  note_added: StickyNote,
  attachment_added: ImagePlus,
  status_changed: Circle,
};

const LABEL = {
  created: "Created",
  viewed: "Viewed",
  action_selected: (e) => {
    const map = { handle: "You said you'd handle this", help: "You asked us to handle this", remind: "Reminder set" };
    return map[e.payload?.action] || "Action selected";
  },
  completed: "Marked complete",
  reminder_scheduled: (e) => `Reminder scheduled for ${fmtDate(e.payload?.remindAt)}`,
  reactivated: "Back in your brief",
  dismissed: "Hidden from future briefs",
  note_added: "Note added",
  attachment_added: (e) => `Photo attached${e.payload?.fileName ? ` (${e.payload.fileName})` : ""}`,
  status_changed: "Status updated",
};

function fmtDate(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  } catch {
    return iso;
  }
}

function fmtDateTime(iso) {
  if (!iso) return "";
  try {
    const d = new Date(iso);
    return d.toLocaleString(undefined, { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export default function TimelineList({ events = [], testId = "timeline-list" }) {
  if (!events.length) return null;
  const sorted = [...events].sort((a, b) => (a.at > b.at ? 1 : -1));
  return (
    <ol className="relative flex flex-col" data-testid={testId}>
      {sorted.map((e, i) => {
        const Icon = ICON[e.type] || Circle;
        const label = LABEL[e.type];
        const text = typeof label === "function" ? label(e) : label || e.type;
        const isLast = i === sorted.length - 1;
        return (
          <li key={e.id || i} className="flex gap-3 pb-4 relative">
            {!isLast && (
              <span
                className="absolute left-[15px] top-8 bottom-0 w-px"
                style={{ background: "var(--ta-border)" }}
                aria-hidden
              />
            )}
            <div
              className="w-8 h-8 rounded-full inline-flex items-center justify-center shrink-0 z-10"
              style={{ background: "var(--ta-accent)", color: "var(--ta-primary)" }}
            >
              <Icon size={15} strokeWidth={2.4} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-medium" style={{ color: "var(--ta-primary)" }}>
                {text}
              </div>
              <div className="text-xs mt-0.5" style={{ color: "var(--ta-text-secondary)" }}>
                {fmtDateTime(e.at)} · {e.actor?.name || "You"}
                {e.actor?.kind === "ai" ? " (AI)" : ""}
                {e.actor?.kind === "system" ? " (system)" : ""}
              </div>
            </div>
          </li>
        );
      })}
    </ol>
  );
}
